import { HttpResponse } from '@angular/common/http';
import { nullSafeIsEquivalent } from '@angular/compiler/src/output/output_ast';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AccountService } from '../../_services/account.service';
import { ModalRegisterPendingComponent } from '../modal-register-pending/modal-register-pending.component';
import { ModalTerminosComponent } from '../modal-terminos/modal-terminos.component';

@Component({
  selector: 'app-modal-register',
  templateUrl: './modal-register.component.html',
  styleUrls: ['./modal-register.component.css']
})
export class ModalRegisterComponent implements OnInit {
  @Input() padre: string;
  form: FormGroup;
  submitted = false;  
  /*errorService = false;
  errorMsg = '';*/
  ruta: string;
  localUrl: any[];
  file = false;
  fileToBig:boolean = false;
  protected terminosSubscription: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
    //this.localUrl[0]="../assets/images/body/tours/01.jpg";
    var email_patter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    this.form = this.formBuilder.group({
      agencia: ['', Validators.required],
      email: ['', Validators.compose([Validators.required,Validators.pattern(email_patter)])],
      password: ['', Validators.compose([Validators.required,Validators.minLength(6)])],
      confirmPassword: ['', Validators.required],
      vendedor: ['', Validators.required],
      direccion: ['', Validators.required],
      code: ['+54'],
      telefono: ['', Validators.compose([Validators.required])],
      imagen:  [],    
      razonSoc: [''],
      twitter: [''],
      facebook: [''],
      instagram: [''],
      terminos: [null, Validators.required]
    }, { validators: this.ConfirmedValidator('password', 'confirmPassword') });

    this.ruta = (this.router.url.split('#')[0]).split('/')[2];

    this.terminosSubscription = this.accountService.terminos.subscribe((data: any) => { 
      this.form.get('terminos').setValue(data);    
    });
  }

  ConfirmedValidator(controlName: string, matchingControlName: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];        
        if (control.value !== matchingControl.value &&  (matchingControl.value !=='' && control.value !=='')) {
            matchingControl.setErrors({ confirmedValidator: true });
        } 
    }   
  }
  keypressTelefono(event){
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57));
  }

  get f() { return this.form.controls; }

  fileEvent(fileInput: any){
    this.fileToBig = false;

    if (fileInput.target.files[0].size/1024/1024 > 2) {
      console.log('file is bigger than 2MB');
      this.fileToBig = true;
      this.file = true; 
      var reader = new FileReader();
       reader.onload = (fileInput: any) => {
           this.localUrl = fileInput.target.result  
           this.file = true;                      
       }
      reader.readAsDataURL(fileInput.target.files[0]); 
      this.form.get('imagen').setValue('');
    }else{
      this.fileToBig = false;
      if (fileInput.target.files.length > 0) {
        const file = fileInput.target.files[0];
        this.form.get('imagen').setValue(file);
      }    
      var reader = new FileReader();
       reader.onload = (fileInput: any) => {
           this.localUrl = fileInput.target.result  
           this.file = true;    
                             
       }
      reader.readAsDataURL(fileInput.target.files[0]);  
    }
    
  } 

  eliminarImagen(){    
    this.file = false;
    this.localUrl = [];
  }

  openTerminos(){
    const modalRef = this.modalService.open(ModalTerminosComponent, { 
      centered: true,  
      size: 'lg',
      backdrop:'static',       
    });  
  }
  onSubmit() {
    this.submitted = true;
    //this.errorService = false;
    
    // stop here if form is invalid
    if (this.form.invalid || this.f.imagen.value === null || this.fileToBig) {
      console.log("error",this.form, this.f.imagen.value, this.fileToBig);
        return;
    }
    var telefono = this.f.code.value+' '+this.f.telefono.value;    
    this.accountService.register(this.f.agencia.value, this.f.email.value, this.f.password.value, this.f.vendedor.value, 
      this.f.direccion.value, telefono, this.f.razonSoc.value, this.f.twitter.value, this.f.facebook.value,
      this.f.instagram.value,  this.f.imagen.value).subscribe(data => {
      if(data instanceof HttpResponse) {
        var response = data.body;
        //Levantar un model
        this.modalService.dismissAll('Cross click');
        const modalRef = this.modalService.open(ModalRegisterPendingComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.padre = this.padre;
        if(response.msg === "SEND_MAIL_SUCCESS" || response.msg === "ERROR_SEND_MAIL") {         
          modalRef.componentInstance.titulo = 'Registro Recibido';
          modalRef.componentInstance.texto = 'Una vez que revisemos y habilitemos su usuario recibirá un correo con la confirmación.'; 
          modalRef.componentInstance.check = 'ok';         
        } else {          
          if(response.msg === "USER_EMAIL_EXIST") {
            modalRef.componentInstance.titulo = 'El usuario ya existe';
            modalRef.componentInstance.check = 'ok';  
          }
          if (response.msg === undefined) {
            modalRef.componentInstance.titulo = 'Operación Fallida';
            modalRef.componentInstance.texto = 'Problemas con el servidor. Contacte al administrador.'; 
            modalRef.componentInstance.check = 'error'; 
          }
          this.submitted = false;
          this.form.reset();
        }
        this.redirectTo(this.router.url);
      }
    });            
  } 

  redirectTo(uri) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate([uri]));
  }
 
}
